import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import React from 'react';
import { mq, getSpace, backgroundClipPath } from '../../../stylesheets/tools';

function ReactModalAdapter({ className, modalClassName, ...props }) {
  return <ReactModal className={modalClassName} portalClassName={className} {...props} />;
}

ReactModalAdapter.propTypes = {
  modalClassName: PropTypes.string,
  className: PropTypes.string
};

const StyledConfirmationLayer = styled(ReactModalAdapter).attrs({
  overlayClassName: 'confirmationLayer__overlay',
  modalClassName: 'confirmationLayer__content'
})`
  .confirmationLayer__overlay {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
  }

  .confirmationLayer__content {
    position: relative;
    width: 100%;
    max-width: 600px;
    margin: ${getSpace('10px')};
    padding: ${getSpace('s')};
    display: flex;
    justify-content: center;
    flex-direction: column;
    ${backgroundClipPath('#000')};
    color: #fff;

    ${mq('m')} {
      padding: ${getSpace('l')};
    }

    a {
      color: #fff;
    }
  }

  .confirmationLayer__headline {
    width: calc(100% - 20px);
  }

  .confirmationLayer__text {
    position: relative;
    z-index: 1;
  }

  .confirmationLayer__close {
    position: absolute;
    top: ${getSpace('s')};
    right: ${getSpace('s')};
    z-index: 2;

    svg {
      fill: #fff;
    }
  }

  .confirmationLayer__accept {
    color: #fff;
    margin: ${getSpace('xxs')} 0;

    a {
      display: inline-block;
      cursor: pointer;
    }

    svg {
      width: 46px;
      height: 15px;
      margin-right: ${getSpace('10px')};
    }
  }
`;

export default StyledConfirmationLayer;
